export default "__VITE_ASSET__DuwDFyfa__"